import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Users, FileText, GraduationCap, ShieldCheck, 
  ArrowRight, CheckCircle, Clock, Building, Award
} from 'lucide-react';

const Services = () => {
  const services = [
    {
      id: 'personel-temini',
      icon: Users,
      title: 'Personel Temini',
      subtitle: 'Mavi ve Beyaz Yaka Personel Çözümleri',
      description: 'İnsan gücünün gerektiği alanlarda çalışan firmalara personel ile ilgili tüm ihtiyaçlarını karşılamak, bu yönde firmanın asıl hedefine ve amacına odaklanmasını sağlıyoruz.',
      features: [
        'Boşaltma ve paketleme personeli',
        'Etiketleme ve üretim personeli',
        'Servis ve ofis personeli',
        'Üretim hattı personeli',
        'Mavi yaka ve beyaz yaka tüm vasıflarda personel',
        'Günlük, dönemsel ve aylık personel temini'
      ],
      image: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg',
      color: '#2A9D8F',
    },
    {
      id: 'bordrolama',
      icon: FileText,
      title: 'Bordrolama Hizmeti',
      subtitle: 'Özlük ve SGK İşlemleri',
      description: 'Tüm teminlerde, personellerin özlük/bordrolama ve SGK hizmetlerine ait işlemler tarafımızdan yapılmakta olup, temin modeline göre teklifler sunuyoruz.',
      features: [
        'SGK bildirimleri ve işlemleri',
        'Ücret bordrosu hazırlama',
        'Özlük dosyası yönetimi',
        'Yasal uyumluluk takibi',
        'Puantaj ve izin yönetimi',
        'Kıdem ve ihbar hesaplamaları'
      ],
      image: 'https://images.pexels.com/photos/5926382/pexels-photo-5926382.jpeg',
      color: '#E76F51',
    },
    {
      id: 'ik-danismanligi',
      icon: Building,
      title: 'İK Danışmanlığı',
      subtitle: 'Stratejik İnsan Kaynakları Yönetimi',
      description: 'İnsan kaynakları süreçlerinizi optimize ederek organizasyonel verimliliğinizi artırmanıza yardımcı oluyoruz.',
      features: [
        'İK süreç analizi ve iyileştirme',
        'Performans yönetim sistemleri',
        'Ücret ve yan haklar danışmanlığı',
        'Organizasyon yapılandırma',
        'Yetenek yönetimi',
        'İK politikaları geliştirme'
      ],
      image: 'https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg',
      color: '#E9C46A',
    },
    {
      id: 'egitim-danismanligi',
      icon: GraduationCap,
      title: 'Eğitim Danışmanlığı',
      subtitle: 'Çalışan Gelişim Programları',
      description: 'Temin edilecek tüm personellere gerekli ön eğitim ile iş ahlakı ve ciddiyetimizi içeren konularda görüşmelerimizi gerçekleştiriyoruz.',
      features: [
        'Oryantasyon eğitimleri',
        'Mesleki gelişim programları',
        'Liderlik eğitimleri',
        'İletişim ve takım çalışması',
        'Teknik beceri eğitimleri',
        'Kişisel gelişim seminerleri'
      ],
      image: 'https://images.pexels.com/photos/7176319/pexels-photo-7176319.jpeg',
      color: '#2A9D8F',
    },
    {
      id: 'isg-danismanligi',
      icon: ShieldCheck,
      title: 'İSG Danışmanlığı',
      subtitle: 'İş Sağlığı ve Güvenliği',
      description: '4857 Sayılı İş Kanunu başta olmak üzere, 6331 Sayılı İş Sağlığı ve Güvenliği Kanunu\'nda yer alan ilgili maddeler nezdinde gereklilikler kapsamında hareket ediyoruz.',
      features: [
        'Risk değerlendirmesi',
        'İSG eğitimleri',
        'Acil durum planları',
        'İş kazası önleme',
        'Yasal uyumluluk denetimleri',
        'İSG dokümantasyonu'
      ],
      image: 'https://images.pexels.com/photos/5846261/pexels-photo-5846261.jpeg',
      color: '#E76F51',
    },
  ];

  const processSteps = [
    {
      icon: Clock,
      title: 'İhtiyaç Analizi',
      description: 'Firmanızın personel ihtiyaçlarını detaylı olarak analiz ediyoruz.'
    },
    {
      icon: Users,
      title: 'Aday Seçimi',
      description: 'Liyakat odaklı değerlendirme ile en uygun adayları belirliyoruz.'
    },
    {
      icon: GraduationCap,
      title: 'Eğitim',
      description: 'Personellere gerekli ön eğitimleri sağlıyoruz.'
    },
    {
      icon: Award,
      title: 'Yerleştirme',
      description: 'Sözleşme sürecini tamamlayarak personeli işe başlatıyoruz.'
    },
  ];

  return (
    <div data-testid="services-page" className="pt-20">
      {/* Hero Section */}
      <section className="section-spacing bg-gradient-to-br from-[#2A9D8F]/5 to-[#E76F51]/5">
        <div className="section-container">
          <div className="text-center max-w-3xl mx-auto">
            <span className="inline-block px-4 py-2 bg-[#2A9D8F]/10 text-[#2A9D8F] rounded-full text-sm font-medium mb-6">
              Hizmetlerimiz
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#264653] mb-6 font-['Outfit']">
              Kapsamlı İK Çözümleri
            </h1>
            <p className="text-lg text-[#264653]/70 leading-relaxed">
              İnsan kaynakları alanında sunduğumuz profesyonel hizmetlerle işletmenizin 
              verimliliğini artırıyor, büyümenize katkı sağlıyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Services Detail */}
      <section className="section-spacing">
        <div className="section-container">
          <div className="space-y-24">
            {services.map((service, index) => (
              <div
                key={service.id}
                id={service.id}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
                data-testid={`service-detail-${service.id}`}
              >
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                    style={{ backgroundColor: `${service.color}15` }}
                  >
                    <service.icon size={32} style={{ color: service.color }} />
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-[#264653] mb-2 font-['Outfit']">
                    {service.title}
                  </h2>
                  <p className="text-[#2A9D8F] font-medium mb-4">{service.subtitle}</p>
                  <p className="text-[#264653]/70 leading-relaxed mb-8">
                    {service.description}
                  </p>
                  <div className="grid sm:grid-cols-2 gap-3">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <CheckCircle className="text-[#2A9D8F] shrink-0 mt-0.5" size={18} />
                        <span className="text-[#264653]/80 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <Link
                    to="/iletisim"
                    className="btn-primary inline-flex items-center gap-2 mt-8"
                    data-testid={`service-cta-${service.id}`}
                  >
                    Teklif Al <ArrowRight size={18} />
                  </Link>
                </div>
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="relative">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="rounded-3xl shadow-xl w-full object-cover h-[400px]"
                    />
                    <div
                      className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full opacity-20"
                      style={{ backgroundColor: service.color }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section-spacing bg-[#264653]" data-testid="process-section">
        <div className="section-container">
          <div className="text-center mb-16">
            <span className="text-[#2A9D8F] font-medium text-sm uppercase tracking-wider">
              Sürecimiz
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 font-['Outfit']">
              Nasıl Çalışıyoruz?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((step, index) => (
              <div key={index} className="text-center" data-testid={`process-step-${index}`}>
                <div className="w-16 h-16 mx-auto bg-[#2A9D8F]/20 rounded-2xl flex items-center justify-center mb-4">
                  <step.icon className="text-[#2A9D8F]" size={28} />
                </div>
                <div className="w-8 h-8 mx-auto bg-[#E76F51] rounded-full flex items-center justify-center text-white font-bold mb-4">
                  {index + 1}
                </div>
                <h3 className="text-xl font-semibold text-white mb-2 font-['Outfit']">
                  {step.title}
                </h3>
                <p className="text-white/70">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-spacing" data-testid="services-cta">
        <div className="section-container">
          <div className="bg-gradient-to-r from-[#2A9D8F] to-[#264653] rounded-3xl p-12 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 font-['Outfit']">
              Sizin İçin Doğru Çözümü Bulalım
            </h2>
            <p className="text-white/90 max-w-xl mx-auto mb-8">
              İhtiyaçlarınıza özel çözümler için uzman ekibimizle görüşün.
            </p>
            <Link
              to="/iletisim"
              className="h-12 px-8 rounded-full font-medium transition-all bg-white text-[#2A9D8F] hover:bg-white/90 inline-flex items-center gap-2"
            >
              Hemen İletişime Geçin <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
